import { Checkbox } from 'stories/components'

export const PrincipalInterestTable = ({
  data,
  handleCheckboxChange,
  handleInputChange,
  onBlur,
}: {
  data: Record<string, any>
  handleCheckboxChange: (index: number) => void
  handleInputChange: (key: string, value: string | number | any[]) => void
  onBlur: Function
}) => (
  <table className="w-full text-sm table-fixed">
    <thead>
      <tr>
        {['Principal and Interest', 'Interest Only', '5/1 ARM', 'Interest Only', 'Option Payment'].map(
          (label, index) => (
            <th key={index} className="m-0 p-2 border">
              <p>{label}</p>
              <p>Fully Amortizing</p>
              <div className="flex items-center justify-center">
                <Checkbox
                  className="w-fit"
                  checked={data?.principalStatus?.[index]}
                  title="Not Offered*"
                  id={`checkbox-${index}`}
                  onChange={() => handleCheckboxChange(index)}
                  onBlur={() => onBlur()}
                />
              </div>
            </th>
          ),
        )}
        <th className="m-0 p-2 border">
          <p>Proposed Loan Type of Loan:</p>
          <input
            type="text"
            value={data?.proposedLoan || ''}
            onChange={(e) => handleInputChange('proposedLoan', e.target.value)}
            className="p-0 text-center w-full"
            onBlur={() => onBlur()}
          />
          <p>Type of Amortization</p>
          <input
            type="text"
            value={data?.typeAmortization || ''}
            onChange={(e) => handleInputChange('typeAmortization', e.target.value)}
            className="p-0 text-center w-full"
            onBlur={() => onBlur()}
          />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="m-0 p-2 border">
          <span>Fixed Rate (</span>
          <input
            type="number"
            value={data?.fixedRate || 0}
            onChange={(e) => handleInputChange('fixedRate', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %)</span>
        </td>
        <td className="m-0 p-2 border">
          <span>Fixed Rate (</span>
          <input
            type="number"
            value={data?.fixedInterestRate || 0}
            onChange={(e) => handleInputChange('fixedInterestRate', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %)</span>
          <p>Interest Only for First 5 Years</p>
        </td>
        <td className="m-0 p-2 border">
          <span>
            Fixed Rate for First 5 Years; Adjustable Each Year After First 5 Years (Initial rate for 1 to 5 is
          </span>
          <input
            type="number"
            value={data?.fixedInitialRate1 || 0}
            onChange={(e) => handleInputChange('fixedInitialRate1', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %; Maximum Rate is </span>
          <input
            type="number"
            value={data?.fixedInitialRate2 || 0}
            onChange={(e) => handleInputChange('fixedInitialRate2', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %)</span>
        </td>
        <td className="m-0 p-2 border">
          <span className="mr-1">
            Interest Only and Fixed Rate for First 5 years; Adjustable Rate Each Year After First 5 Years (Initial rate
            for 1 to 5 is
          </span>
          <input
            type="number"
            value={data?.interestFixedRate1 || 0}
            onChange={(e) => handleInputChange('interestFixedRate1', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %; Maximum Rate is </span>
          <input
            type="number"
            value={data?.interestFixedRate2 || 0}
            onChange={(e) => handleInputChange('interestFixedRate2', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %)</span>
        </td>
        <td className="m-0 p-2 border">
          <span>Adjustable Rate for Entire Term of the Mortgage (Rate in month 1 is </span>
          <input
            type="number"
            value={data?.adjustableRate1 || 0}
            onChange={(e) => handleInputChange('adjustableRate1', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %; Rate in month 2 through year 5 is </span>
          <input
            type="number"
            value={data?.adjustableRate2 || 0}
            onChange={(e) => handleInputChange('adjustableRate2', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %; Maximum Rate is </span>
          <input
            type="number"
            value={data?.adjustableRate3 || 0}
            onChange={(e) => handleInputChange('adjustableRate3', e.target.value)}
            className="p-0 text-center w-16"
            onBlur={() => onBlur()}
          />
          <span> %)</span>
        </td>
        <td className="m-0 p-2 border">Explanation of Type of Proposed Loan Product:</td>
      </tr>
    </tbody>
  </table>
)

export default PrincipalInterestTable
